import React from "react";
import { Linkedin } from "lucide-react";
import { GlassCard } from "./GlassCard";

const team = [
    {
        id: "purnima",
        name: "Dr. Purnima Jalihal",
        role: "CTO",
        blurb: "30+ years in desalination and ocean energy · 8 patents · former Director, National Institute of Ocean Technology",
        img: "https://customer-assets.emergentagent.com/job_startup-blur-design/artifacts/mnigi9gq_image.png",
        linkedin: "https://www.linkedin.com/in/purnima-jalihal-352511186/",
    },
    {
        id: "abhishek",
        name: "Abhishek Padmanabhan",
        role: "CEO",
        blurb: "A decade deploying energy hardware, software & policy in the field",
        img: "https://customer-assets.emergentagent.com/job_startup-blur-design/artifacts/ri81mmva_image.png",
        linkedin: "https://www.linkedin.com/in/abhishekpaddy/",
    },
];

export const Team = () => (
    <section
        id="team"
        data-testid="team-section"
        className="relative py-24 md:py-32 px-6 md:px-10 bg-lavender"
    >
        <div className="max-w-7xl mx-auto">
            <div className="max-w-3xl">
                <span className="section-label">The Team</span>
                <h2 className="mt-4 font-display font-black text-ocean text-4xl md:text-5xl lg:text-6xl tracking-tighter leading-[1.05]">
                    Deep science. Deep water. Deep commitment.
                </h2>
                <p className="mt-5 text-inkblue text-base md:text-lg leading-relaxed">
                    A founding team with decades of combined expertise across
                    ocean energy, desalination, and industrial engineering.
                </p>
            </div>

            <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 gap-6">
                {team.map((m, i) => (
                    <GlassCard
                        key={m.id}
                        className="p-8 flex flex-col items-center text-center"
                        data-testid={`team-card-${i}`}
                    >
                        <div className="relative rounded-full overflow-hidden w-40 h-40 mb-6 bg-ocean/5 ring-4 ring-white/60 shadow-[0_10px_30px_rgba(15,42,68,0.12)]">
                            <img
                                src={m.img}
                                alt={m.name}
                                className="w-full h-full object-cover transition-transform duration-700 hover:scale-105"
                                loading="lazy"
                            />
                        </div>
                        <h3 className="font-display font-black text-ocean text-xl md:text-2xl tracking-tight">
                            {m.name}
                        </h3>
                        <p className="mt-1.5 text-teal text-xs font-bold uppercase tracking-[0.22em]">
                            {m.role}
                        </p>
                        <p className="mt-4 text-inkblue text-sm leading-relaxed max-w-[16rem]">
                            {m.blurb}
                        </p>
                        <a
                            href={m.linkedin}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="mt-5 w-10 h-10 rounded-full bg-ocean/5 hover:bg-ocean text-ocean hover:text-white flex items-center justify-center transition"
                            aria-label={`${m.name} LinkedIn`}
                            data-testid={`team-linkedin-${i}`}
                        >
                            <Linkedin size={16} />
                        </a>
                    </GlassCard>
                ))}
            </div>
        </div>
    </section>
);

export default Team;
